module.exports = __webpack_public_path__ + "1c56207314b3700814a492331ccaafaa.png";